class CompanionMaterialItemConstants {
  static readonly PROTRACTOR = 'qti-protractor';
  static readonly RULER = 'qti-rule';
  static readonly CALCULATOR = 'qti-calculator';
}

export default CompanionMaterialItemConstants;
